/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import config from "@/config";
import axios from "axios";
import store from "@/store";

export default {
	getEntities(objectsIds) {
		return axios.post(
			`${config.PORTAL_URL}/api/v5/portal/entities`, {ids: objectsIds}, {
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getAccount(accountID) {
		return axios.get(`${config.PORTAL_URL}/api/v5/accounts/${accountID}`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	},

	getStation(stationID) {
		return axios.get(`${config.PORTAL_URL}/api/v5/stations/${stationID}`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	},

	getShow(showID) {
		return axios.get(`${config.PORTAL_URL}/api/v5/shows/${showID}`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	},

	getShowSettings(showID) {
		return axios.get(`${config.PORTAL_URL}/api/v5/shows/${showID}/settings`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	}
}
